"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DependentAvailableAgentIdentifierAccessLevel = void 0;
exports.DependentAvailableAgentIdentifierAccessLevel = {
    Admin: "admin",
    Editor: "editor",
    Viewer: "viewer",
};
